import { IStringLocalizer } from "../../utilities/IStringLocalizer";
import { CustomColumn, QuestionType } from "../Models/Surveys/SurveyDataModel";

export class CustomDataTableColumnProvider {
    public static getFCNDataTableColumns(localizer: IStringLocalizer): CustomColumn[] {
        return [
            {
                customColumnName: "FCN Number",
                customColumnIndex: 0,
                customColumnType: QuestionType.Text,
                required: true,
                validationMessage: localizer.localizeString("Answer is required.")
            },
            {
                customColumnName: "Material",
                customColumnIndex: 1,
                customColumnType: QuestionType.Text,
                required: true,
                validationMessage: localizer.localizeString("Answer is required.")
            },
            {
                customColumnName: "Supplier",
                customColumnIndex: 2,
                customColumnType: QuestionType.Text,
                required: true,
                validationMessage: localizer.localizeString("Answer is required.")
            },
            {
                customColumnName: "Restrictions",
                customColumnIndex: 3,
                customColumnType: QuestionType.Text,
                required: false
            }
        ];
    }

    public static getPolymerDataTableColumns(localizer: IStringLocalizer): CustomColumn[] {
        return [
            {
                customColumnName: "Trade Name",
                customColumnIndex: 0,
                customColumnType: QuestionType.Text,
                required: false
            },
            {
                customColumnName: "Grade",
                customColumnIndex: 1,
                customColumnType: QuestionType.Text,
                required: false
            },
            {
                customColumnName: "Code",
                customColumnIndex: 2,
                customColumnType: QuestionType.Text,
                required: false
            },
            {
                customColumnName: "Issue Date",
                customColumnIndex: 3,
                customColumnType: QuestionType.Datetime,
                required: true,
                validationMessage: localizer.localizeString("Answer is required.")
            },
            {
                customColumnName: "Limitations",
                customColumnIndex: 4,
                customColumnType: QuestionType.Text,
                required: false
            }
        ];
    }

    public static getPrintingTechniqueDataTableColumns(localizer: IStringLocalizer): CustomColumn[] {
        return [
            {
                customColumnName: "Printing Technique",
                customColumnIndex: 0,
                customColumnType: QuestionType.MultipleDropdown,
                predefinedAnswers: [
                    {
                        nativeAnswer: localizer.localizeString("Rotogravure"),
                        languageToAnswerMap: {
                            "en": "Rotogravure"
                        }
                    },
                    {
                        nativeAnswer: localizer.localizeString("Offset"),
                        languageToAnswerMap: {
                            "en": "Offset"
                        }
                    },
                    {
                        nativeAnswer: localizer.localizeString("UV"),
                        languageToAnswerMap: {
                            "en": "UV"
                        }
                    },
                    {
                        nativeAnswer: localizer.localizeString("Flexo"),
                        languageToAnswerMap: {
                            "en": "Flexo"
                        }
                    },
                    {
                        nativeAnswer: localizer.localizeString("Digital"),
                        languageToAnswerMap: {
                            "en": "Digital"
                        }
                    },
                    {
                        nativeAnswer: localizer.localizeString("Other"),
                        languageToAnswerMap: {
                            "en": "Other"
                        }
                    }
                ],
                required: true,
                validationMessage: localizer.localizeString("Answer is required.")
            },
            {
                customColumnName: "Printing Ink System",
                customColumnIndex: 1,
                customColumnType: QuestionType.Text,
                required: true,
                validationMessage: localizer.localizeString("Answer is required.")
            }
        ];
    }

    public static getProductionSiteDataTableColumns(localizer: IStringLocalizer): CustomColumn[] {
        return [
            {
                customColumnName: "Production Site",
                customColumnIndex: 0,
                customColumnType: QuestionType.Text,
                required: true,
                validationMessage: localizer.localizeString("Answer is required.")
            },
            {
                customColumnName: "Country of Origin",
                customColumnIndex: 1,
                customColumnType: QuestionType.Text,
                required: true,
                validationMessage: localizer.localizeString("Answer is required.")
            },
            {
                customColumnName: "Comment",
                customColumnIndex: 2,
                customColumnType: QuestionType.Text,
                required: false
            }
        ];
    }
}